<template lang="pug">
  ValidationProvider(:rules="rules" v-slot="{ errors }")
    v-autocomplete(:items="items" item-text="text" item-value="value" return-object  v-model="valuefield"  :disabled="disabled" outlined dense multiple :error="errors.length > 0" @input="inputFill", :label="label")
      template(v-slot:prepend)
        v-icon(v-if="valuefield.length > 0" color="green" size="18") mdi-check
        v-icon(v-else color="red accent-2" size="18") mdi-asterisk
      template(v-slot:selection)
        //- nada, permanecen ocultos
    span.red--text.text--accent-2(v-if="errors.length > 0")
      v-icon(color="red accent-2") mdi-alert
      |  {{ errors[0] }}
</template>

<script>
  export default {
    name: "BaseAutocompleteEmptyField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: function(){
          return []
        }
      }
    },
    data:() => ({
      valuefield: null,
    }),
    computed: {
      isRequired(){
        return this.rules.includes('required');
      }
    },
    watch: {
      value: function(val){
        this.valuefield = val;
      }
    },
    created(){
      this.valuefield = this.value;
    },
    methods:{
      inputFill(){
        this.$emit('input', this.valuefield);
      },
    },
  }
</script>

<style lang="sass">
</style>